import {
  Button,
  TextField,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { toast } from "react-toastify";
import Modal from "@mui/material/Modal";
import MapPicker from "../../Utils/MapPicker.js";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const ProfileDetail = () => {
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [data, setData] = useState([]);
  const [First, setFirst] = useState("");
  const [Last, setLast] = useState("");
  const [Gender, setGender] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [DOB, setDOB] = useState("");
  const [Profile, setProfile] = useState("");
  const [redius, setRedius] = useState()

  const center = {
    lat: 28.6139, // Default to Delhi
    lng: 77.2090,
  };
  const [location, setLocation] = useState({});
  const [address, setAddress] = useState('');

  const User = () => {
    axios
      .get(
        `https://app1.crazzyhub.com/api/admin/multi-vendor-my-profile/`,

        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data?.profile_data[0]);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  };

  useEffect(() => {
    User();
  }, []);

  const Update = () => {
    const reqbody = new FormData();
    reqbody.append("first_name", First);
    reqbody.append("last_name", Last);
    reqbody.append("gender", Gender);
    reqbody.append("mobile", Mobile);
    reqbody.append("email", Email);
    reqbody.append("dob", DOB);
    reqbody.append("profile_picture", Profile);
    reqbody.append("latitude", location.lat)
    reqbody.append("longitude", location.lng)
    reqbody.append("location", address)
    reqbody.append("radius", redius)

    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/multi-vendor-update-profile/`,
        reqbody,

        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.status);
        User()
        handleClose1()
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  };

  const updateFunctionality = (event, row) => {
    event.preventDefault();
    setFirst(row?.first_name);
    setLast(row?.last_name);
    setGender(row?.gender);
    setMobile(row?.mobile);
    setEmail(row?.email);
    setDOB(row?.dob);
    setRedius(row?.radius)
    setLocation({
      lat: Number(row?.latitude) || 28.6139,
      lng: Number(row?.longitude) || 77.2090,
    })

    setAddress(row?.location)
    setProfile("");
    handleOpen1();
  };
  return (
    <>
      <div className="max-w-6xl mx-auto p-6 space-y-6 text-sm text-gray-800">
        {/* Header */}
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-semibold">Profile Details</h2>
          <Button
            variant="contained"
            size="small"
            onClick={(event) => updateFunctionality(event, data)}
          >
            Update
          </Button>
        </div>

        {/* Profile Card */}
        <div className="bg-white border border-gray-300 shadow-sm rounded-lg p-6 space-y-6">
          <div className="flex flex-col md:flex-row gap-6 items-start md:items-center">
            {/* Profile Picture */}
            <div className="flex-shrink-0">
              <img
                src={data?.profile_picture || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1DJ07G3NozsXrAMSaNo4PfOanC3fylWdbRg&s'}
                alt="Profile"
                className="w-24 h-24 object-cover rounded-full border"
              />
            </div>

            {/* Personal Details */}
            <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {[
                ['First Name', data?.first_name?.toUpperCase()],
                ['Last Name', data?.last_name?.toUpperCase()],
                ['Gender', data?.gender],
                ['Mobile', data?.mobile],
                ['Email', data?.email],
                ['DOB', data?.dob],
                ['Role', data?.role],
                ['Latitude', data?.latitude],
                ['Longitude', data?.longitude],
                ['Address', data?.location],
                ['Referral Income', data?.referral_income],
                ['Radius', data?.radius],
              ].map(([label, value], idx) => (
                <div key={idx}>
                  <p className="text-gray-500">{label}</p>
                  <p className="font-medium text-blue-900">{value || '-'}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Store Info */}
        <div className="bg-white border border-gray-300 shadow-sm rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-4 text-gray-700">Store Information</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              ['Store', data?.store?.toUpperCase()],
              ['Business Type', data?.store_business_type?.toUpperCase()],
              ['Business Sub Type', data?.store_business_sub_type?.toUpperCase()],
            ].map(([label, value], idx) => (
              <div key={idx}>
                <p className="text-gray-500">{label}</p>
                <p className="font-medium text-blue-900">{value || '-'}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Account Info */}
        <div className="bg-white border border-gray-300 shadow-sm rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-4 text-gray-700">Account Information</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              ['Account Number', data?.bank_account_number],
              ['IFSC Code', data?.ifsc_code],
              ['GST Number', data?.gst_no],
              ['PAN Number', data?.pan_no],
              ['QR Code', data?.store_qr_code],
            ].map(([label, value], idx) => (
              <div key={idx}>
                <p className="text-gray-500">{label}</p>
                <p className="font-medium text-blue-900">{value || '-'}</p>
              </div>
            ))}
          </div>
        </div>
      </div>


      <Modal
        open={open1}
        onClose={handleClose1}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: 1200 }} className="rounded-2xl !border-0  !overflow-y-auto">

          <p className=" text-center font-semibold  text-2xl">Update Profile</p>
          <div
            id="child-modal-title "
            className="!text-black !underline !font-bold  !text-center !text-xl  grid  grid-cols-3  gap-3"
          >

            <TextField
              size="small"
              id="outlined-basic"
              label="First Name "
              variant="outlined"
              className="!w-[100%] !mt-3"
              value={First}
              onChange={(event) => setFirst(event.target.value)}
            />
            <TextField
              size="small"
              id="outlined-basic"
              label="Last Name "
              variant="outlined"
              className="!w-[100%] !mt-3"
              value={Last}
              onChange={(event) => setLast(event.target.value)}
            />
            <TextField
              size="small"
              id="outlined-basic"
              label="Gender "
              variant="outlined"
              className="!w-[100%] !mt-3"
              value={Gender}
              onChange={(event) => setGender(event.target.value)}
            />
            <TextField
              size="small"
              id="outlined-basic"
              label="Email "
              variant="outlined"
              className="!w-[100%] !mt-3"
              value={Email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <TextField
              size="small"
              id="outlined-basic"
              type="date"
              variant="outlined"
              className="!w-[100%] !mt-3"
              value={DOB}
              onChange={(event) => setDOB(event.target.value)}
            />
            <TextField
              size="small"
              id="outlined-basic"
              label=""
              variant="outlined"
              className="!w-[100%] !mt-3"
              type="file"
              onChange={(event) => setProfile(event.target.files[0])}
            />

            <TextField
              size="small"
              id="outlined-basic"
              type="number"
              label="Redius in (mtr) "
              variant="outlined"
              className="!w-[100%] !mt-3"
              value={redius}
              onChange={(event) => setRedius(event.target.value)}
            />
          </div>


          <MapPicker location={location} setLocation={setLocation} address={address} setAddress={setAddress} />

          <Button
            onClick={handleClose1}
            variant="contained"
            color="warning"
            className="!py-2 !mt-3"
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="success"
            className="!py-2 !px-5 !font-bold !mt-3 !float-right"
            onClick={Update}
          >
            Update
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default ProfileDetail;
